import React from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function PdfViewerModal({ open, onClose, pdfUrl }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", top: 10, right: 10 }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ height: "90vh", p: 0 }}>
        {pdfUrl ? (
          <iframe
            src={pdfUrl}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Assessment PDF"
          />
        ) : (
          "No PDF Available"
        )}
      </DialogContent>
    </Dialog>
  );
}
